export default __webpack_public_path__ + "193c21377781032f68f757c67fdeb045.png";